import styled from '@emotion/styled';

const StyledWrapper = styled.div(
  {
    padding: '14px 20px 14px 20px',
    borderRadius: '6px',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '18px'
  },
  ({ theme }) => ({
    border: `1px solid ${theme.palette.colors.columbiaBlue}`,
    backgroundColor: theme.palette.colors.white
  })
);

export default StyledWrapper;
